define.alias("shared/components/shared/credentials/tiktok-refresh-confirm", "settings/components/shared/credentials/tiktok-refresh-confirm");